/* eslint-disable prettier/prettier */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { RootState } from '../../app/store';
import {
  getAllGuestBymonth,
  getAllTotalSupportBuisnessCount,
  getBookingSummary,
  getDownloadTableData,
  getTotalBookingsDetails,
} from '../../services/dashboardService';
import { IDashbord } from './dashboardInterface';

const initialState: IDashbord = {
  isGetNoOfGuestByMonth: false,
  allGuestByMonthList: [],
  isGetNoOfFacilityByMonth: false,
  allGuestByLocationList: [],
  isGetNoOfFacilityCountByMonth: false,
  allFacilitiesCountByMonth: [],
  isGetTotalCount: false,
  allTotalCount: [],
  isGetTotalSupportBuisness: false,
  allTotalCountSupprtBuisness: [],
  isTotalBookingsLoading: false,
  TotalBusiness: {
    data: [],
  },
  graphMonth: moment().format('YYYY-MM'),
  tableSummary: {
    data: [],
  },
  istableSummaryFetching: false,
  istableSummarydownloading: false,
};

export const dashboardGraphInfoSlice = createSlice({
  name: 'dashboardGraphInfo',
  initialState,
  reducers: {
    setGraphMonth: (state, action: PayloadAction<string>) => {
      state.graphMonth = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchAllGuestByMonth.pending, (state) => {
        state.isGetNoOfGuestByMonth = true;
      })
      .addCase(fetchAllGuestByMonth.fulfilled, (state, action) => {
        state.isGetNoOfGuestByMonth = false;
        state.allGuestByMonthList = action.payload?.data;
      })
      .addCase(fetchAllGuestByMonth.rejected, (state) => {
        state.isGetNoOfGuestByMonth = false;
      })

      .addCase(totalSupportBuisneessByMonth.pending, (state) => {
        state.isGetTotalSupportBuisness = true;
      })
      .addCase(totalSupportBuisneessByMonth.fulfilled, (state, action) => {
        state.isGetTotalSupportBuisness = false;
        state.allTotalCountSupprtBuisness = action.payload.data;
      })
      .addCase(totalSupportBuisneessByMonth.rejected, (state) => {
        state.isGetTotalSupportBuisness = false;
      })
      .addCase(getTotalBookings.pending, (state) => {
        state.isTotalBookingsLoading = true;
      })
      .addCase(getTotalBookings.fulfilled, (state, action) => {
        state.isTotalBookingsLoading = false;
        state.TotalBusiness.data = action.payload.data;
      })
      .addCase(getTotalBookings.rejected, (state) => {
        state.isTotalBookingsLoading = false;
      })
      .addCase(getTableSummary.pending, (state) => {
        state.istableSummaryFetching = true;
      })
      .addCase(getTableSummary.fulfilled, (state, action) => {
        state.istableSummaryFetching = false;
        state.tableSummary.data = action?.payload?.data;
      })
      .addCase(getTableSummary.rejected, (state) => {
        state.istableSummaryFetching = false;
      })
      .addCase(downloadTableData.pending, (state) => {
        state.istableSummarydownloading = true;
      })
      .addCase(downloadTableData.fulfilled, (state) => {
        state.istableSummarydownloading = false;
      })
      .addCase(downloadTableData.rejected, (state) => {
        state.istableSummarydownloading = false;
      });
  },
});
export const fetchAllGuestByMonth = createAsyncThunk(
  'dashboardGraphInfoSlice/fetchAllGuestByMonth',
  async (id: string) => {
    const response = await getAllGuestBymonth(id);
    return response;
  }
);

export const totalSupportBuisneessByMonth = createAsyncThunk(
  'dashboardGraphInfoSlice/totalSupportBuisneessByMonth',
  async (id: string) => {
    const response = await getAllTotalSupportBuisnessCount(id);
    return response;
  }
);

export const getTotalBookings = createAsyncThunk(
  'dashboardGraphInfoSlice/getTotalBookings',
  async ({
    month,
    currency,
    facilityId,
  }: {
    month: string;
    currency: string;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      currency: string;
      facilityId: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      currency,
      facilityId: facilityId,
    };
    const response = await getTotalBookingsDetails(params);
    return response;
  }
);

export const getTableSummary = createAsyncThunk(
  'dashboardGraphInfoSlice/getTableSummary',
  async ({
    month,
    searchTerm,
    filter,
    page,
    facilityId,
  }: {
    month: string;
    searchTerm: string;
    filter: string;
    page: number;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      searchTerm: string;
      bookingStatus?: string;
      size: number;
      page: number;
      facilityId: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      searchTerm,
      size: 5,
      page,
      facilityId: facilityId || '',
    };
    if (filter !== '') {
      params.bookingStatus = filter;
    }
    const response = await getBookingSummary(params);
    return response;
  }
);

export const downloadTableData = createAsyncThunk(
  'dashboardGraphInfoSlice/download-table-data',
  async ({
    month,
    searchTerm,
    filter,
    facilityId,
  }: {
    month: string;
    searchTerm: string;
    filter: string;
    facilityId: string;
  }) => {
    const params: {
      year: string;
      month: string;
      searchTerm: string;
      bookingStatus?: string;
      facilityId?: string;
    } = {
      year: month.split('-')[0],
      month: month.split('-')[1],
      searchTerm,
    };
    if (facilityId != '') {
      params.facilityId = facilityId;
    }
    if (filter !== '') {
      params.bookingStatus = filter;
    }

    const response = await getDownloadTableData(params);

    return response;
  }
);

export const dashboardInfo = (state: RootState) => state.dasboardInfo;
export const { setGraphMonth } = dashboardGraphInfoSlice.actions;

export const dashboardInfoReducer = dashboardGraphInfoSlice.reducer;
